/* eslint-disable no-undef */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import TextLabel from '../simple/TextLabel'
import parse from 'html-react-parser'

import { FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Radio, RadioGroup, Typography } from '@material-ui/core'

const styles = theme => ({
    formControl: {
        margin: theme.spacing(0)
    },
    buttons: {
        position: 'relative'
    },
    button: {
        width: '100%',
        marginRight: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5)
    },
    radio: {
        minWidth: '110px',
        alignItems: 'start'
    },
    radioButton: {
        color: theme.palette.primaryColor + '!important'
    },
    selectButton: {
        marginTop: theme.spacing(1.7),
        width: '100%'
    },
    errorText: {
        marginTop: theme.spacing(0.8),
        color: theme.palette.error.main + '!important',
        fontSize: '0.9rem!important',
        textAlign: theme.errorText && theme.errorText.textAlign ? theme.errorText.textAlign : 'center!important'
    },
    lgTitle: {
        fontSize: '1.5rem',
        marginBottom: theme.spacing(1.5),
        color: theme.palette.text.primary,
        lineHeight: 1.15
    },
    customTitleSize: {
        marginTop: 0
    },
    optionHelper: {
        color: theme.body2Color,
        textAlign: theme.optionHelper ? theme.optionHelper.textAlign : ''
    },
    helperText: {
        marginTop: theme.spacing(1.5),
        fontSize: '0.875rem',
        color: theme.palette.text.primary,
        lineHeight: 1.43
    },
    label: {
        marginBottom: theme.spacing(1.5) + 'px!important'
    },
    group: {
        marginTop: 15
    },
    [theme.breakpoints.down(600)]: {
        questionWrapper: {
            padding: '4px!important'
        }
    }
})

class RadioButtonsQuestion extends Component {
    handleChange = value => {
        this.props.onValueChanged(this.props.question.id, value)
    }

    render() {
        const { classes, question, value } = this.props

        return (
            <>
                <Grid
                    item
                    xs={parseInt(question.xsCols)}
                    sm={parseInt(question.smCols)}
                    className={classes.questionWrapper + ' question-id-' + question.id}
                >
                    <FormControl component="fieldset" className={classes.formControl} fullWidth style={{ marginTop: 0 }}>
                        {question.title && (
                            <>
                                {!question.titleSize && (
                                    <FormLabel component="legend" className={classes.label}>
                                        {question.title}
                                    </FormLabel>
                                )}
                                {question.titleSize && (
                                    <Typography variant={question.titleSize} gutterBottom className={classes.customTitleSize}>
                                        {question.title}
                                    </Typography>
                                )}
                            </>
                        )}
                        {question.description && <Typography component="span">{parse(question.description)}</Typography>}
                        <RadioGroup
                            row
                            aria-label={question.title}
                            name={question.name}
                            className={question.title && classes.group}
                            value={String(value)}
                            onChange={event => this.handleChange(event.target.value)}
                        >
                            {question.options &&
                                question.options.map((option, key) => {
                                    return (
                                        <FormControlLabel
                                            value={option.value && String(option.value)}
                                            control={<Radio color="primary" className={classes.radioButton} />}
                                            label={<TextLabel label={option.label} />}
                                            className={classes.radio + ' radioLabel ' + (option.label.length > 250 ? 'longOption' : '')}
                                            key={key}
                                        />
                                    )
                                })}
                        </RadioGroup>
                        {question.valid === false && (
                            <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
                                <FormHelperText className={classes.errorText}>{question.errorMessage}</FormHelperText>
                            </Grid>
                        )}
                        {question.helperText && (
                            <Grid>
                                <FormHelperText className={classes.helperText}>{parse(question.helperText)}</FormHelperText>
                            </Grid>
                        )}
                    </FormControl>
                </Grid>
            </>
        )
    }
}

export default withStyles(styles)(RadioButtonsQuestion)
